var map = {
	"./plain-sticker-A.png": 71,
	"./plain-sticker-B.png": 72,
	"./plain-sticker-C.png": 73,
	"./plain-sticker-D.png": 74,
	"./plain-sticker-E.png": 75,
	"./plain-sticker-F.png": 76,
	"./plain-sticker-G.png": 77,
	"./plain-sticker-H.png": 78,
	"./plain-sticker-I.png": 79,
	"./plain-sticker-J.png": 80,
	"./plain-sticker-K.png": 81,
	"./plain-sticker-L.png": 82,
	"./plain-sticker-M.png": 83,
	"./plain-sticker-N.png": 84,
	"./plain-sticker-O.png": 85,
	"./plain-sticker-P.png": 86,
	"./plain-sticker-Q.png": 87,
	"./plain-sticker-R.png": 88,
	"./plain-sticker-S.png": 89,
	"./plain-sticker-T.png": 90,
	"./plain-sticker-U.png": 91,
	"./plain-sticker-V.png": 92,
	"./plain-sticker-W.png": 93,
	"./plain-sticker-X.png": 94,
	"./plain-sticker-Y.png": 95,
	"./plain-sticker-Z.png": 96
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 468;